import React, { Component } from 'react'
import MyNavbar from "../../components/Navbar/MyNavbar";
import TicketDetail from '../../components/Ticket/TicketingDetail/TicketDetail';
export default class TicketDetailPage extends Component {
    
    render() {
        return (
            <div>
                 <MyNavbar />
                 <TicketDetail />
            </div>
        )
    }
}
